import { FC, memo } from 'react';

import styles from './styles.module.css';

type Props = {
  title: string;
};

export const PageTitle: FC<Props> = memo(({ title }) => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{title}</h2>
    </div>
  );
});
